import moment from "moment";

export const dbDateFormat = (date) => moment(date).format("Y-MM-DD");

export const displayDateFormat = (date, format = "DD MMM Y") =>
  moment(date).format(format);

export const countAdminPackageByItineraryType = (
  reduxPackageData,
  itinerary_type
) =>
  reduxPackageData.filter((pkg) => pkg.itinerary_type === itinerary_type)
    .length || 0;

export const countAccommodationAndExperienceByDay = (
  reduxPackageData,
  sequenceDate,
  itinerary_type
) =>
  reduxPackageData
    .filter((x) => x.itinerary_type === itinerary_type)
    .map(({ child }) =>
      child
        .slice(0, 1)
        .filter(({ start_date, end_date, itinerary_type }) =>
          itinerary_type === 4
            ? dbDateFormat(start_date) <= dbDateFormat(sequenceDate) &&
              dbDateFormat(end_date) > dbDateFormat(sequenceDate)
            : dbDateFormat(start_date) === dbDateFormat(sequenceDate)
        )
    )
    .flat(1).length;

export const calculateDiscountedAmount = (amount, discountPercentage = 0) => {
  if (discountPercentage < 0 || discountPercentage > 100 || amount < 0) {
    throw new Error("Invalid discount percentage or amount");
  }
  return (amount - (amount * discountPercentage) / 100).toFixed(2);
};

export const calculateCustomerPackageBeforeDiscountAmount = (packageData) => {
  return packageData
    .reduce((finalPrice, item) => {
      const selectedChild = item.child.find((child) => child.selected);
      if (!selectedChild) return finalPrice;

      const currentPrice =
        selectedChild.itinerary_type === 4
          ? moment(selectedChild.end_date).diff(
              moment(selectedChild.start_date),
              "days"
            ) * parseFloat(selectedChild.price)
          : parseFloat(selectedChild.price);

      return finalPrice + currentPrice;
    }, 0)
    .toFixed(2);
};

export const calculateAdminPackageBeforeDiscountAmount = (packageData) => {
  return packageData
    .reduce((finalPrice, item) => {
      const selectedChild = item.child[0];
      if (!selectedChild) return finalPrice;

      const currentPrice =
        selectedChild.itinerary_type === 4
          ? moment(selectedChild.end_date).diff(
              moment(selectedChild.start_date),
              "days"
            ) * parseFloat(selectedChild.price)
          : parseFloat(selectedChild.price);

      return finalPrice + currentPrice;
    }, 0)
    .toFixed(2);
};

export const generateDateRange = (startDate, days) => {
  const start = new Date(startDate);
  const end = new Date(start);
  end.setDate(end.getDate() + days);

  const dates = [];
  const currentDate = new Date(start);

  while (currentDate <= end) {
    dates.push(new Date(currentDate));
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
};

const currencySign = "€";
const handleNaN = (value, returnValue = 0) =>
  isNaN(value) ||
  value === undefined ||
  value === "undefined" ||
  value === null ||
  value === "null"
    ? returnValue
    : Number(value);

export const constant = {
  amountWithCurrency: (amount, currency = currencySign) =>
    `${currency} ${handleNaN(amount).toFixed(2)}`,
  pickAmount: (amount) => amount.match(/\d+(\.\d+)?/g),
  handleNaN,
  currencySign,
};

export const getDateDifference = (start, end, unit = "days") => {
  if (unit === "days") {
    return moment(end)
      .startOf("day")
      .diff(moment(start).startOf("day"), "days");
  }
  return moment(end).diff(moment(start), unit);
};

export const addDaysToDate = (date, days, keepTime = false) => {
  return keepTime
    ? moment(date).add(days, "days").format("YYYY-MM-DD HH:mm:ss")
    : moment(date).add(days, "days").startOf("day").format("YYYY-MM-DD");
};
